import React, { useCallback, useEffect, useState } from 'react';
import { Field } from 'redux-form';
import { OutlinedTextFields, MIDatePicker, CommonDropdownOutlined } from '@Components';
import { dynamic_validator2 } from '../../../../../utils/validation';
import { r_maxLength } from '../../../../../utils/validation/restrictions';
import { API_URL } from '../../../../../utils/config';
import moment from 'moment';
import { US_CONSTANTS, SSN } from '../utils/constants';
import { BeneIdentityHelperText } from '../../../../bene-info-correction/styles';
import { BENE_IDENTITY_HELPER_TEXT } from '../../../../bene-info-correction/utils';

export const GenerateField = (props: {
  field: any;
  countryCode?: string;
  dropDownDefaultValue?: string;
  isNiumForexUser?: boolean;
  isPolandBeneIdentiyNumberRequired?: boolean;
}): React.ReactElement => {
  const {
    field,
    countryCode,
    dropDownDefaultValue,
    isNiumForexUser,
    isPolandBeneIdentiyNumberRequired
  } = props;
  const [formData, setFormData] = useState<any>({});

  const validateField = useCallback(
    (value: any, allValues: any, props: any, name: string) => {
      let errors;
      //eslint-disable-next-line
      errors = dynamic_validator2(value, field.validations, errors, {
        isCorp: false,
        allValues,
        name
      });
      return errors;
    },
    [field.validations]
  );

  useEffect(() => {
    if (isNiumForexUser && dropDownDefaultValue) {
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        issuing_country: dropDownDefaultValue
      }));
    }
  }, [isNiumForexUser, dropDownDefaultValue]);

  const handleBoxDropdownChange = (name: string, event: any) => {
    const { value } = event;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const getPlaceholder = (label: string): string => {
    return label === SSN ? US_CONSTANTS.ssnPlaceholder : label;
  };

  switch (field.category) {
    case 'text_field':
      return (
        <>
          <Field
            parentClassName="form-text-field"
            type={field.type}
            name={field.name}
            key={field.name}
            label={field.label}
            component={OutlinedTextFields}
            disableUnderlineStyling={true}
            shrink={true}
            placeholder={getPlaceholder(field.label)}
            validate={[validateField]}
            normalize={
              field.validations?.length?.max ? r_maxLength(field.validations.length.max) : null
            }
          />
          {isPolandBeneIdentiyNumberRequired && field.name === 'beneficiary_identity_number' && (
            <BeneIdentityHelperText>{BENE_IDENTITY_HELPER_TEXT}</BeneIdentityHelperText>
          )}
        </>
      );
    case 'date_picker':
      return (
        <Field
          type={field.type}
          name={field.name}
          placeholder={field.label}
          component={MIDatePicker}
          disableUnderlineStyling={true}
          InputLabelProps={{
            shrink: true
          }}
          customPlaceholder={countryCode === 'US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'}
          validate={[validateField]}
          minDate={
            field.range?.min_identifier &&
            moment().add(field.range.min_offset, field.range.min_identifier)
          }
          maxDate={
            field.range?.max_identifier &&
            moment().add(field.range.max_offset, field.range.max_identifier)
          }
          countryCode={countryCode}
        />
      );
    case 'dropdown':
      return (
        <Field
          bindToThisObject={formData[field.name]}
          parentClassName="form-text-field"
          type={field.type}
          name={field.name}
          key={field.name}
          label={field.label}
          component={CommonDropdownOutlined}
          width="100%"
          showLabel={true}
          labelText={field.label}
          disableUnderlineStyling={true}
          shrink={true}
          placeholder={field.label}
          validate={[validateField]}
          onDropdownChange={(event: any) => {
            handleBoxDropdownChange(field.name, event);
          }}
          url={`${API_URL + field?.url}`}
        />
      );

    default:
      return <></>;
  }
};
